// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__179UG","footer":"styles_footer__1G8zn"};